var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item",class:[
    {
      active: _vm.isActive,
      disabled: _vm.item.disabled,
    },
    _vm.item.class ]},[_c('b-link',_vm._b({staticClass:"d-flex align-items-center"},'b-link',_vm.linkProps,false),[(_vm.item.svgIcon)?_c('icon',{attrs:{"name":_vm.item.svgIcon}}):_c('GjIcon',{attrs:{"name":_vm.item.gjIcon}}),_c('span',{staticClass:"menu-title text-truncate"},[_vm._v(_vm._s(_vm.item.title))]),(_vm.item.tag)?_c('b-badge',{staticClass:"mr-1 ml-auto",attrs:{"pill":"","variant":_vm.item.tagVariant || 'primary'}},[_vm._v(" "+_vm._s(_vm.item.tag)+" ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }